module.exports = __webpack_public_path__ + "img/kanha_logo.a1dc3ed8.svg";